import styled from '@emotion/styled';
import PolarisIcon from '@/components/_common/PolarisIcon';

const IconStyled = styled(PolarisIcon)`
  display: block;
`;

export default IconStyled;
